import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { CONFIG } from "src/config";

export const defaultNS = "common";

export const resources = {
	he: {
		emptyState: {
			productsList: {
				title: "אין מוצרים להצגה",
				description: "נקה את סינון כדי לראות את כל המוצרים",
				action: "נקה סינון",
			},
		},
		minimumOrderAlert: {
			title: "יש ",
			description: "",
		},
		deliveryDiscount: {
			title: "תקנה ב {{amount}} ש״ח ותקבל  המשלוח בחינם",
			description: "חסר לך עוד {{amount}} ש״ח כדי לקבל משלוח בחינם",
			deliveryPriceInfo: "מחיר משלוח: ₪{{price}}",
		},
		deliverySettings: {
			title: "הגדרות משלוח",
			deliveryPrice: "מחיר משלוח",
			freeDeliveryPrice: "סכום מינימלי למשלוח חינם",
			minimumOrder: "סכום הזמנה מינימלי",
			removeDeliveryPrice: "הסר מחיר משלוח",
			setDeliveryPrice: "קבע מחיר משלוח",
			deliveryPriceRemoved: "מחיר המשלוח הוסר בהצלחה",
			deliveryPriceUpdated: "מחיר המשלוח עודכן בהצלחה",
			settingsUpdated: "ההגדרות עודכנו בהצלחה",
		},
		// static
		errors: {
			required_error: "שדה חובה",
			positive: "ערך חייב להיות גדול מ 0",
		},
		common: {
			anonymousUser: "משתמש אנונימי",
			paymentType: "סוג תשלום",
			paymentTypes: {
				j5: "תשלום באמצעות J5",
				external: "תשלום חיצוני",
				none: "לא מוגדר",
			},
			paymentStatus: "סטטוס תשלום",
			paymentStatuses: {
				pending: "ממתין",
				pending_j5: "ממתין J5",
				external: "חיצוני",
				completed: "הושלם",
				failed: "נכשל",
				refunded: "הוחזר",
			},
			clientTypes: {
				user: "לקוח פרטי",
				company: "חברה",
			},
			company: "חברה",
			individual: "לקוח פרטי",
			clientType: "סוג לקוח",
			emptyField: "לא קיים מידע",

			units: {
				kg: "ק״ג",
				gram: "גרם",
				liter: "ליטר",
				ml: "מל",
				unit: "יחידה",
			},
			discount: "הנחה",
			cancel: "ביטול",
			confirm: "אישור",
			edit: "ערוך",
			delete: "מחק",
			create: "צור",
			back: "חזרה",
			loading: "טוען...",
			update: "עדכן",
			view: "צפה",
			dashboard: "לוח בקרה",
			// Admin sidebar navigation labels (dedicated so they don't affect
			// the generic labels used elsewhere in the app).
			nav: {
				dashboard: "דשבורד",
				orders: "הזמנות",
				organizations: "חברות",
				users: "לקוחות",
				products: "מוצרים ומלאי",
				categories: "קטגוריות",
				subCategories: "תתי-קטגוריות",
				discounts: "מבצעים",
				suppliers: "ספקים",
				inventoryCertificate: "חשבוניות ספקים",
				deliveryNotes: "תעודות משלוח",
				invoices: "הפקת חשבוניות",
				customerInvoices: "חשבוניות לקוחות",
				budget: "חובות לקוחות",
				settings: "הגדרות",
				logout: "יציאה",
				problemOrders: "בעיות בהזמנות",
			},
			manageStore: "ניהול חנות",
			manageUsers: "ניהול משתמשים",
			manageOrders: "ניהול הזמנות",
			billing: "חיוב",
			deliveryNotesManagement: "ניהול תעודות משלוח",
			invoices: "חשבוניות",
			createInvoice: "צור חשבונית",
			deliveryNotes: "תעודות משלוח",
			budget: "ניהול תקציב",
			createDeliveryNote: "צור תעודת משלוח",
			selectOrganization: "בחר ארגון",
			dateRange: "טווח תאריכים",
			fromDate: "מתאריך",
			toDate: "עד תאריך",
			generateInvoice: "צור חשבונית",
			search: "חפש",
			adminSettings: "הגדרות",
			settings: "הגדרות",
			deliveryPrice: "משלוח",
			removeDeliveryPrice: "הסר מחיר משלוח",
			restoreDeliveryPrice: "שחזר מחיר משלוח",
			currentDeliveryPrice: "מחיר משלוח נוכחי",
			deliveryPriceRemovedDescription: "מחיר המשלוח הוסר מהזמנה זו",
			deliveryPriceRemoveDescription: "לחץ על 'הסר' כדי לבטל את עלות המשלוח להזמנה זו",
			deliveryChargesWaived: "עלות משלוח בוטלה",
			usingStoreDefaultDelivery: "משתמש במחיר משלוח ברירת מחדל של החנות",
			status: "סטטוס",
			companyName: "שם חברה",
			discounts: "מבצעים",
			admin: "מערכת ניהול",
			searchProducts: "חפש מוצרים לפי טקסט חופשי",
			addToCart: "הוסף לעגלה",
			favorites: "שמורים",
			orders: "הזמנות",
			addProduct: "הוסף מוצר",
			searchProduct: "חפש מוצר",
			profile: "חשבון",
			logout: "התנתק",
			goToCart: "מעבר לעגלה",
			login: "התחברות",
			city: "עיר",
			close: "סגירה",
			save: "שמור",
			street: "רחוב",
			streetNumber: "מס רחוב",
			lang: "שפה",
			name: "שם",
			organization: "ארגון",
			organizations: "ארגונים",
			organizationGroups: "קבוצות ארגונים",
			date: "תאריך",
			order: "הזמנה",
			note: "הערה",
			suppliers: "ספקים",
			inventoryCertificate: "חשבוניות ספקים",
			inventoryCertificatePage: {
				documentDate: "תאריך תעודה",
				supplier: "ספק",
				invoiceNumber: "מספר חשבונית",
				rowNumber: "שורה",
				itemName: "שם פריט",
				quantity: "כמות",
				purchasePriceIn: "מ קניה ב",
				lineDiscount: "הנחת שורה",
				netPriceAfterDiscount: "מחיר נטו לאחר הנחה",
				profitPercent: "% רווח",
				salesPriceFrom: "מ מכירה",
				purchasePriceC: "מ קניה ג",
				netPurchaseValue: "ערך קניה נטו",
				addRow: "הוסף שורה",
				removeRow: "מחק שורה",
				save: "שמור",
				saveModalTitle: "אישור שמירה",
				saveModalDescription: "הטבלה הבאה מציגה את המוצרים שיעודכנו עם הערכים הישנים והחדשים:",
				noProductsToUpdate: "אין מוצרים לעדכן",
				confirmSave: "אשר ושמור",
				summary: "סיכום",
				totalBeforeVat: "סה״כ לפני מע״מ",
				vatAmount: "מע״מ (18%)",
				totalWithVat: "סה״כ כולל מע״מ",
				createTab: "צור",
				viewTab: "צפה בכל",
				rowsCount: "מספר שורות",
				noInvoices: "לא נמצאו תעודות מלאי",
				searchPlaceholder: "חיפוש לפי ספק או מספר חשבונית",
				filterBySupplier: "כל הספקים",
				dateFrom: "מתאריך",
				dateTo: "עד תאריך",
				clearFilters: "נקה סינון",
				noMatchingInvoices: "לא נמצאו חשבוניות התואמות לסינון",
				draftsTab: "טיוטות",
				noDrafts: "אין טיוטות שמורות",
				saveDraft: "שמור טיוטה",
				draftSaved: "הטיוטה נשמרה",
				draftSaving: "שומר טיוטה...",
				draftAutoSaved: "נשמר אוטומטית כטיוטה",
				existingDraftsTitle: "יש לך תעודות שלא הושלמו",
				existingDraftsDescription:
					"התחלת להכניס תעודות שעדיין לא נשמרו סופית. אפשר להמשיך מהמקום שבו הפסקת.",
				viewDraftsButton: "עבור לטיוטות",
				continueEditing: "המשך עריכה",
				deleteDraft: "מחק טיוטה",
				duplicateInvoiceChecking: "בודק אם המספר כבר קיים...",
				duplicateInvoiceTitle: "מספר החשבונית כבר קיים במערכת",
				duplicateInvoiceSameSupplierTitle: "שים לב! כבר קיימת תעודה עם מספר זה לספק הזה",
				duplicateInvoiceOtherSupplierTitle: "מספר החשבונית כבר קיים במערכת (ספק אחר)",
				duplicateInvoiceDescription:
					"בדוק שאינך מכניס את אותה תעודה פעמיים. אלו התעודות הקיימות עם אותו מספר:",
				duplicateInvoiceDraftBadge: "טיוטה",
				duplicateInvoiceCompletedBadge: "תעודה שנשמרה",
				duplicateInvoiceView: "צפה בתעודה",
				productNotInSystem: "מוצר לא קיים במערכת",
				newProductsTitle: "מוצרים חדשים שלא קיימים במערכת (צריך להכניס):",
				supplierPriceHistory: {
					button: "היסטוריית מחירי ספקים",
					title: "היסטוריית מחירי ספקים",
					subtitle: "כל הקניות של המוצר לפי ספק, מחיר ותאריך",
					loading: "טוען נתונים...",
					noHistory: "לא נמצאה היסטוריית קניות מספקים למוצר זה",
					date: "תאריך",
					supplier: "ספק",
					supplierCode: "קוד ספק",
					purchasePrice: "מחיר קנייה",
					lineDiscount: "הנחה",
					netPrice: "מחיר נטו",
					salePrice: "מחיר מכירה",
					quantity: "כמות",
					invoiceNumber: "מספר חשבונית",
				},
			},
			namePlaceholder: "הכנס שם ארגון",
			discountPercentagePlaceholder: "הכנס אחוז הנחה",
			nameOnInvoicePlaceholder: "הכנס שם לחשבונית",
			actionsLabel: "פעולות",
			organizationNotFound: "ארגון לא נמצא",
			failedToLoad: "נכשל בטעינת הארגון",
			basicInfo: "מידע בסיסי",
			noDiscount: "אין הנחה",
			notSet: "לא מוגדר",
			organizationId: "מזהה ארגון",
			backToList: "חזרה לרשימה",
			billingAccounts: "חשבונות לקוח",
			addBillingAccount: "הוסף חשבון לקוח",
			editBillingAccount: "ערוך חשבון לקוח",
			accountName: "שם חשבון",
			accountNamePlaceholder: "הכנס שם חשבון",
			accountNumber: "מספר חשבון",
			accountNumberPlaceholder: "הכנס מספר חשבון",
			noBillingAccounts: "אין חשבונות לקוח מוגדרים",
			confirmDeleteBillingAccount: "האם אתה בטוח שברצונך למחוק את חשבון הלקוח הזה?",
			actions: {
				view: "צפה",
				cancel: "ביטול",
			},
			editProductName: "ערוך שם מוצר",
			sku: 'מק"ט',
			description: "תיאור",
			price: "מחיר",
			selectCategory: "בחר קטגוריה",
			category: "קטגוריה",
			priceType: "סוג מחיר",
			enterPriceType: "הכנס סוג מחיר",
			unit: "יחידה",
			kg: "קג",
			gram: "גרם",
			brand: "מותג",
			country: "מדינה",
			manufacturer: "יצרן",
			supplier: "יבואן",
			image: "תמונה",
			vat: 'מע"מ',
			weight: "משקל",
			volume: "נפח",
			none: "לא מוגדר",
			liter: "ליטר",
			ml: "מל",
			fullName: "שם מלא",
			email: "אימייל",
			address: "כתובת",
			phone: "טלפון",
			floor: "קומה",
			apartmentEnterNumber: "כניסה",
			apartmentNumber: "מס דירה",
			password: "סיסמא",
			profitPercentage: "אחוז רווח",
			purchasePrice: "מחיר רכישה",
			users: "לקוחות",
			products: "מוצרים",
			categories: "קטגוריות",
			amount: "כמות",
			addToFavorite: "הוסף למועדפים",
			remove: "הסר",
			orderStatutes: {
				draft: "לא הושלם",
				pending: "בהמתנה",
				processing: "בהכנה",
				delivered: "הגיע",
				cancelled: "בוטל",
				completed: "הסתיים בהצלחה",
				refunded: "הוחזר",
				in_delivery: "במשלוח",
			},
			navLinks: {
				saved: "שמורים",
				discounts: "מבצעים",
			},
			chatbot: "צ'אט",
			chatbotClose: "סגור צ'אט",
			chatbotPlaceholder: "שלום! איך אפשר לעזור?",
			chatbotInputPlaceholder: "הקלד הודעה...",
			chatbotSend: "שלח",
			chatbotEmptyState: "שלח הודעה כדי להתחיל",
			chatbotError: "שגיאה בשליחת ההודעה. נסה שוב.",
			bundle: "חבילה",
			discountName: "שם מצבע",
			noDiscountsAvailable: "אין מבצעים זמינים",
			checkBackLater: "בדוק מאוחר יותר למבצעים חדשים",
			active: "פעיל",
			off: "הנחה",
			items: "פריטים",
			subtotal: "סכום ביניים",
			total: "סה״כ",
			waived: "בוטל",
			added: "נוסף",
			removed: "הוסר",
			modified: "שונה",
			add: "הוסף",
			for: "במחיר",
			included: "כלול",
			viewProducts: "צפה במוצרים",
			deliveryDate: "תאריך משלוח מועדף",
			nameOnInvoice: "שם מלא בחשבונית",
			clientComment: "הערות ללקוח",
		},
		auth: {
			welcome: {
				login: {
					title: "חזרת לעוד שופינג?",
					description: "הכנס את פרטיך ותחזור לקנייה. העגלה שלך מתגעגעת אליך!",
					button: "עדיין לא רשום? הצטרף עכשיו!",
				},
				signup: {
					title: "קונה חדש בשכונה?",
					description:
						"הצטרף אלינו ופתח עולם של מבצעים מדהימים. מלא את פרטיך ונתחיל את ההרפתקה הזו!",
					button: "כבר רשום? התחבר כאן!",
				},
			},
			form: {
				errors: {
					invalidEmail: "אימייל לא תקין",
					codes: {
						"auth/invalid-credential": "אימייל או סיסמה לא נכונים",
						"auth/email-already-in-use": "כתובת האימייל כבר רשומה במערכת",
						"auth/invalid-email": "אימייל לא תקין",
						"auth/weak-password": "הסיסמה חייבת להכיל לפחות 6 תווים",
						generic: "אירעה שגיאה. נסה שוב.",
					},
				},
				email: {
					label: "אימייל",
					placeholder: " הכנס אימייל",
				},
				password: {
					label: "סיסמה",
					placeholder: " הכנס סיסמה",
				},
				forgotPassword: {
					link: "שכחת סיסמה?",
					title: "איפוס סיסמה",
					description: "הכנס את כתובת האימייל שלך ונשלח אליך קישור לאיפוס הסיסמה.",
					submit: "שלח קישור לאיפוס",
					success: "אם קיים חשבון עם כתובת אימייל זו, נשלח אליו קישור לאיפוס הסיסמה. בדוק את תיבת הדואר שלך.",
					backToLogin: "חזרה להתחברות",
				},
			},
		},

		paymentSummary: {
			title: "סיכום ההזמנה",
			totalCost: "מחיר סופי",
			deliveryPrice: "משלוח",
		},
		// dynamic

		homePage: {
			title: "כל מה שהמשרד שלך צריך",
			description: "על איכות במשרד לא מתפשרים",
			action: "מעבר לחנות",
			pricesBeforeVat: "המחירים הינם לפני מע״מ",
			forOfficesOnly: "האתר למשרדים בלבד",

			services: {
				shipping: {
					title: "משלוח חינם",
					description: "כל הזמנות ללא עלות משלוח",
				},
				support: {
					title: "שרות לקוחות 24/7",
					description: "צור קשר מתי שאתה צריך",
				},
				payment: {
					title: "תשלום מאובטח",
					description: "שהכסף שלך בטוח",
				},
				moneyBack: {
					title: "החזר כספי",
					description: "החזר מלא על כל בעיה במוצר",
				},
			},

			popularCategories: "קטגוריות פופולאריות",
		},

		favorites: {
			viewProduct: "צפה במוצר",
			remove: "הסר",
		},

		profilePage: {
			title: "חשבון משתמש",
			editProfile: "ערוך חשבון",
			subTitleView: "פרטי חשבון",
			subTitleEdit: "עריכה פרטי חשבון",
			basicInfo: "מידע כללי",
			addressInfo: "כתובת",
			systemInfo: "מידע מערכת",
			noAddress: "אין כתובת להצגה",
			saveChanges: "שמור שינויים",
			updateSuccessTitle: "פרופיל עודכן",
			updateSuccessDescription: "הפרופיל שלך עודכן בהצלחה.",
			updateFailedTitle: "עדכון נכשל",
			updateFailedDescription: "אירעה שגיאה בעדכון הפרופיל שלך.",
			paymentTypeDefault: "תשלום ברירת מחדל",
			paymentTypeDelayed: "תשלום מאוחר",
			systemFieldUserId: "מזהה משתמש",
			systemFieldCompanyId: "מזהה חברה",
			systemFieldStoreId: "מזהה חנות",
			systemFieldTenantId: "מזהה דייר",
			columns: {
				client: "לקוח",
				address: "כתובת",
				phone: "מספר טלפון",
				clientType: "סוג לקוח",
				clientAuth: "לקוח רשום",
			},
		},
		contactForm: {
			submitSuccessTitle: "הטופס נשלח",
			submitSuccessDescription: "תודה! נחזור אליכם בהקדם.",
			submitFailedTitle: "שליחה נכשלה",
			submitFailedDescription: "אירעה שגיאה בשליחת הטופס. נסו שוב.",
		},
		discountsPage: {
			noDiscountsAvailable: "אין מבצעים זמינים",
			checkBackLater: "בואו נחזור בעוד מספר ימים",
			tableHeader: {
				actions: "פעולות",
			},
		},

		cart: {
			shoppingCart: "סל קניות",
			proceedToCheckout: "המשך לתשלום",
			backToShop: "חזרה לחנות",
			emptyState: {
				title: "עגלת קניות שלך ריקה",
				description: "כאן יופיעו המוצרים שהזמנת",
			},
		},

		ordersPage: {
			title: "הזמנות שלי",
			createOrder: "צור הזמנה",
			searchPlaceholder: "חיפוש הזמנה / לקוח...",
			sync: "סנכרון",
			export: "ייצוא",
			tabs: {
				active: "פעילות",
				completed: "הסתיימו",
				all: "הכל",
			},
			columns: {
				orderId: "מזהה הזמנה",
				customerName: "שם לקוח",
				createdBy: "נוצר על ידי",
				paymentType: "סוג תשלום",
				date: "תאריך",
				deliveryDate: "תאריך אספקה מועדף",
				sum: "סכום",
				status: "סטטוס",
				client: "שם לקוח",
				address: "כתובת",
				actions: "פעולות",
				endOrder: "סיום הזמנה",
			},
			createdBy: {
				admin: "מנהל",
				user: "לקוח",
			},
			actions: {
				cancelOrder: "בטל הזמנה",
				viewOrder: "צפה בהזמנה",
				viewDetails: "צפה בפרטים",
				editInfo: "ערוך מידע",
				delete: "מחק",
				acceptOrder: "אישור הזמנה",
				deliveredOrder: "הזמנה הגיע",
				paidOrder: "הזמנה שולמה",
				duplicateOrder: "הזמן שוב",
				setOnDelivery: "יצא למשלוח",
				chargeOrder: "חייב הזמנה",
				endOrder: "סיום הזמנה",
				createPaymentLink: "צור לינק חיוב",
			},
			filters: {
				allCategory: "כל הקטגוריות",
				date: "תאריך",
				status: "סטטוס",
				filters: "סינונים",
				typeHere: "הקלד כאן",
				selectStatus: "בחר סטטוס",
				allStatuses: "כל הסטטוסים",
				apply: "החל",
			},
			pagination: {
				showing: "מציג {{start}} עד {{end}} פריטים",
			},
			confirmApprove: {
				title: "אישור הזמנה",
				message:
					"לאשר את ההזמנה? תיווצר תעודת משלוח ולא ניתן יהיה לבטל את הפעולה.",
				confirm: "אשר הזמנה",
			},
			confirmCancel: {
				title: "ביטול הזמנה",
				message: "לבטל את ההזמנה? פעולה זו אינה ניתנת לשחזור.",
				confirm: "בטל הזמנה",
			},
			noOrders: "אין הזמנות",
			orderDetails: {
				title: "פרטי הזמנה",
				orderId: "מזהה הזמנה",
				changeStatus: "שנה סטטוס",
				save: "שמור",
				print: "הדפס",
				customer: {
					title: "לקוח",
					name: "שם",
					email: "אימייל",
					phone: "טלפון",
					viewProfile: "צפה בפרופיל",
				},
				orderInfo: {
					title: "מידע הזמנה",
					shipping: "משלוח",
					payMethod: "שיטת תשלום",
					status: "סטטוס",
					downloadInfo: "הורד מידע",
				},
				delivery: {
					title: "משלוח ל",
					city: "עיר",
					viewProfile: "צפה בפרופיל",
				},
				payment: {
					title: "מידע תשלום",
					businessName: "שם עסק",
					phone: "טלפון",
				},
				notes: {
					title: "הערות",
					placeholder: "הקלד הערה",
					save: "שמור הערה",
				},
				products: {
					title: "שם מוצר",
					productName: "שם מוצר",
					price: "מחיר",
					quantity: "כמות",
					total: "סה״כ",
					editTitle: "ערוך מוצרי הזמנה",
					changesSummary: "סיכום שינויים",
					addProduct: "הוסף מוצר",
					addExternal: "הוסף מוצר חיצוני",
					searchProduct: "חפש מוצר",
					searchPlaceholder: "הקלד לחיפוש...",
					namePlaceholder: "הכנס שם מוצר...",
					orderId: "מזהה הזמנה",
				},
				summary: {
					title: "סיכום הזמנה",
					subtotal: "סכום ביניים",
					tax: "מע״מ (18%)",
					discount: "הנחה",
					total: "סה״כ",
					paymentDone: "תשלום בוצע",
				},
				documents: {
					title: "מסמכים",
					deliveryNote: "תעודת משלוח",
					invoice: "חשבונית",
					ezInvoice: "חשבונית EzCount",
					ezDeliveryNote: "תעודת משלוח EzCount",
					download: "הורד",
					createInvoice: "צור חשבונית",
					createDeliveryNote: "צור תעודת משלוח",
					documentDate: "תאריך למסמך",
					selectDateDeliveryNote: "בחר תאריך לתעודת משלוח",
					selectDateInvoice: "בחר תאריך לחשבונית",
				},
			},
		},

		orderSuccessPage: {
			actionButton: "מעבר לחנות",
			title: "ההזמנה שלך התקבלה בהצלחה! תודה רבה על הרכישה שלך.",
			description: "אנו שולחים לך כעת אישור למייל, ונעדכן אותך ברגע שהמוצרים יצאו למשלוח.",
			orderId: "מזהה הזמנה",
			orderCost: "סכום ההזמנה",
			anonymousMessage:
				"רוצה ליהנות מהזמנות מהירות ומבצעים מיוחדים? הירשם עכשיו ותוכל לעקוב אחרי ההזמנות שלך בקלות, לקבל עדכונים על מבצעים בלעדיים, ועוד! 	הצטרף למשפחתנו ותהנה מכל היתרונות.",
		},
		orderErrorPage: {
			title: "התשלום לא הושלם",
			description:
				"אירעה שגיאה בעיבוד התשלום. ההזמנה שלך נשמרה במערכת ומנהל החנות קיבל התראה. ניצור איתך קשר בהקדם להשלמת התשלום.",
			orderId: "מזהה הזמנה",
			actionButton: "חזרה לחנות",
		},
		paymentPendingPage: {
			title: "קיבלנו את ההזמנה שלך!",
			description: "לצערנו, נתקלנו בבעיה טכנית בעיבוד התשלום.\nאל דאגה — ההזמנה שלך נשמרה במערכת ונמצאת בטיפול.\nנציג שלנו ייצור איתך קשר בהקדם להשלמת התשלום.\n\nתודה על הסבלנות ועל האמון!",
			actionButton: "חזרה לחנות",
		},
		checkout: {
			title: "פרטי ההזמנה",
			order: "הזמן",
		},
		problemOrdersPage: {
			title: "בעיות בהזמנות",
			summary: {
				total: "סה״כ הזמנות",
				withProblems: "הזמנות עם בעיות",
				clean: "הזמנות תקינות",
				g1Count: "סטטוס לא הושלם",
				g2Count: "תשלום לא הושלם",
				g3Count: "חסר מסמך",
			},
			filters: {
				all: "הכל",
				g1: "סטטוס לא הושלם",
				g2: "תשלום לא הושלם",
				g3: "חסר מסמך",
			},
			columns: {
				date: "תאריך",
				customer: "לקוח",
				status: "סטטוס",
				paymentStatus: "סטטוס תשלום",
				paymentType: "סוג תשלום",
				total: "סכום",
				invoice: "חשבונית",
				deliveryNote: "תעודת משלוח",
				groups: "קבוצות",
				orderId: "מזהה הזמנה",
				actions: "פעולות",
			},
			emptyState: "אין הזמנות עם בעיות",
			searchPlaceholder: "חיפוש לפי מזהה הזמנה / לקוח...",
			actions: {
				viewDetails: "פרטים",
				refresh: "רענן",
				cancelOrder: "ביטול הזמנה",
				cancelling: "מבטל...",
				markCompleted: "סמן כהושלם",
				completing: "מסמן...",
			},
			confirmCancel: {
				title: "ביטול הזמנה",
				message: "האם אתה בטוח שברצונך לבטל את ההזמנה הזו?",
				paidWarning: "שים לב: עבור הזמנות שחויבו (J5 או חיצוני) ביטול זה אינו מבטל את אמצעי התשלום ואינו מחזיר ערכים בספרי החשבונות.",
			},
			confirmComplete: {
				title: "סימון הזמנה כהושלמה",
				message: "האם אתה בטוח שברצונך לסמן את ההזמנה הזו כהושלמה?",
			},
			pagination: {
				showing: "מציג {{start}} עד {{end}} פריטים",
			},
			aria: {
				hasInvoice: "יש חשבונית",
				noInvoice: "אין חשבונית",
				hasDeliveryNote: "יש תעודת משלוח",
				noDeliveryNote: "אין תעודת משלוח",
			},
		},
		store: {},
		admin: {
			budget: {
				title: "ניהול תקציב",
				noAccounts: "אין חובות פתוחים",
				totalDebits: "סה״כ חיובים",
				totalCredits: "סה״כ תשלומים",
				balance: "יתרת חוב",
				addManual: "הוסף תנועה ידנית",
				txType: "סוג תנועה",
				amount: "סכום",
				runningBalance: "יתרה",
				billingAccount: "חשבון חיוב",
				paymentRef: "אסמכתא",
				noTransactions: "אין תנועות",
			},
			createCategory: "הוסף קטגוריה",
			createOrder: {
				title: "צור הזמנה",
				description: "צור הזמנה חדשה עבור לקוח",
				noOrganization: "ללא חברה",
				selectOrganization: "בחר חברה",
				selectOrganizationPlaceholder: "בחר חברה",
				discount: "הנחה",
				selectBillingAccount: "בחר חשבון חיוב",
				selectBillingAccountPlaceholder: "בחר חשבון חיוב",
				createOrder: "צור הזמנה",
			},
			discountsPage: {
				title: "ניהול מבצעים",
				description: "נהל את מבצעים של חנות שלך כאן",
				createDiscount: "צור מצבע",
				discountType: "סוג מצבע",
				prodcutQuantity: "מספר המוצרים הנדרש",
				discountFinalPrice: "מחיר סופי של המצבע",
				tableHeader: {
					name: "שם מצבע",
					type: "סוג מצבע",
					status: "סטטוס",
					actions: "פעולות",
				},
			},
			clientsPage: {
				title: "לקוחות",
				addClient: "הוסף לקוח",
				searchPlaceholder: "חיפוש לפי שם, אימייל או מזהה",
				noUsersFound: "לא נמצאו לקוחות",
				showing: "מציג {{start}} עד {{end}} פריטים",
				actions: {
					view: "צפייה",
					delete: "מחיקה",
				},
				columns: {
					name: "שם",
					address: "כתובת",
					phone: "טלפון",
					clientType: "סוג לקוח",
					paymentType: "סוג תשלום",
				},
			},
			clientProfile: {
				title: "פרופיל לקוח",
				basicInformation: "מידע בסיסי",
				addressInformation: "מידע כתובת",
				systemInformation: "מידע מערכת",
				systemInfoDescription: "מידע זה נוצר אוטומטית על ידי המערכת ולא ניתן לעריכה",
				created: "נוצר",
				lastActivity: "פעילות אחרונה",
				anonymous: "אנונימי",
				registered: "רשום",
				removeClient: "הסר לקוח",
				confirmRemoval: "אשר הסרה",
				removeConfirmMessage: "האם אתה בטוח שברצונך להסיר את",
				actionCannotBeUndone: "פעולה זו לא ניתנת לביטול.",
				saveChanges: "שמור שינויים",
				displayNameRequired: "שם תצוגה נדרש",
				emailRequired: "אימייל נדרש",
				invalidEmailFormat: "פורמט אימייל לא תקין",
				phoneCannotBeEmpty: "מספר טלפון לא יכול להיות ריק",
				anonymousAccount: "חשבון אנונימי",
				accountStatus: "סטטוס חשבון",
				clientId: "מזהה לקוח",
				companyId: "מזהה חברה",
				storeId: "מזהה חנות",
				tenantId: "מזהה דייר",
				errorLoadingProfile: "שגיאה בטעינת הפרופיל",
				clientProfileNotFound: "פרופיל הלקוח לא נמצא",
				individual: "לקוח פרטי",
				company: "חברה",
				organizationManagement: "ניהול ארגון",
				discount: "הנחה",
				invoiceName: "שם בחשבונית",
				removeFromOrganization: "הסר מארגון",
				noOrganizationAssigned: "לא משויך לארגון",
				selectOrganizationBelow: "בחר ארגון מהרשימה למטה כדי לשייך את הלקוח",
				assignToOrganization: "שייך לארגון",
				selectOrganization: "בחר ארגון",
				noOrganization: "ללא ארגון",
				noOrganizationsFound: "לא נמצאו ארגונים",
				createOrganization: "צור ארגון",
				organizationMember: "חבר בארגון",
				searchOrganizations: "חפש ארגונים...",
				noSearchResults: "לא נמצאו ארגונים התואמים לחיפוש שלך",
				failedToAssignOrganization: "שגיאה בשיוך הלקוח לארגון",
				failedToRemoveOrganization: "שגיאה בהסרת הלקוח מהארגון",
				failedToUpdateOrganization: "שגיאה בעדכון שיוך הארגון",
			},
			addProductPage: {
				title: "הוסף מוצר",
				skuAlreadyInUse: 'המק"ט כבר בשימוש',
				skuTakenBy: 'ברקוד {{sku}} תפוס על ידי הפריט "{{name}}"',
				openTakenProduct: "פתח את המוצר הקיים",
				freeSkuSuggestions: "ברקודים פנויים הבאים (לחץ לבחירה):",
				createFailed: "שגיאה ביצירת המוצר. נסה שוב.",
				validationFailed: "יש שדות חובה חסרים או לא תקינים. בדוק את השדות המסומנים באדום.",
				notAuthorized: "אין לך הרשאה ליצור מוצר בחנות זו. פנה לתמיכה.",
			},
			organizationsPage: {
				title: "ארגונים",
				createOrganization: "צור ארגון",
				editOrganization: "ערוך ארגון",
				name: "שם",
				enterName: "הכנס שם ארגון",
				discountPercentage: "אחוז הנחה",
				nameOnInvoice: "שם בחשבונית",
				enterInvoiceName: "הכנס שם לחשבונית",
				companyNumber: "חפ",
				group: "קבוצת ארגונים",
				selectGroup: "בחר קבוצת ארגונים",
				noGroup: "ללא קבוצה",
				confirmDelete: "האם אתה בטוח שברצונך למחוק את הארגון הזה?",
				organizations: "ארגונים",
				namePlaceholder: "הכנס שם ארגון",
				discountPercentagePlaceholder: "הכנס אחוז הנחה",
				nameOnInvoicePlaceholder: "הכנס שם לחשבונית",
				companyNumberPlaceholder: "הכנס חפ",
				actionsLabel: "פעולות",
				organizationNotFound: "ארגון לא נמצא",
				failedToLoad: "נכשל בטעינת הארגון",
				basicInfo: "מידע בסיסי",
				noDiscount: "אין הנחה",
				notSet: "לא מוגדר",
				organizationId: "מזהה ארגון",
				backToList: "חזרה לרשימה",
				billingAccounts: "חשבונות לקוח",
				addBillingAccount: "הוסף חשבון לקוח",
				editBillingAccount: "ערוך חשבון לקוח",
				accountName: "שם חשבון",
				accountNamePlaceholder: "הכנס שם חשבון",
				accountNumber: "מספר חשבון",
				accountNumberPlaceholder: "הכנס מספר חשבון",
				noBillingAccounts: "אין חשבונות לקוח מוגדרים",
				confirmDeleteBillingAccount: "האם אתה בטוח שברצונך למחוק את חשבון הלקוח הזה?",
				actions: {
					view: "צפה",
				},
				organizationUsers: "לקוחות הארגון",
				addOrganizationUser: "הוסף לקוח לארגון",
				editOrganizationUser: "ערוך לקוח ארגון",
				noOrganizationUsers: "אין לקוחות משויכים לארגון",
				failedToLoadUsers: "נכשל בטעינת לקוחות הארגון",
				failedToLoadAvailableUsers: "נכשל בטעינת רשימת הלקוחות הזמינים",
				clientNamePlaceholder: "הכנס שם לקוח",
				clientEmailPlaceholder: "הכנס כתובת אימייל",
				clientPhonePlaceholder: "הכנס מספר טלפון",
				clientCompanyNamePlaceholder: "הכנס שם חברה",
				confirmRemoveOrganizationUser: "האם אתה בטוח שברצונך להסיר את {{name}} מהארגון?",
				enterClientEmail: "הכנס אימייל של לקוח",
				searchClient: "חפש לקוח",
				clientNotFound: "לא נמצא לקוח עם האימייל שסיפקת",
				failedToAssignClient: "נכשל בשיוך הלקוח לארגון",
				alreadyInThisOrganization: "לקוח זה כבר משויך לארגון הנוכחי.",
				alreadyInOrganization: 'לקוח זה כבר משויך לארגון "{{name}}".',
				alreadyInOrganizationDescription:
					'כדי לשייך אותו לארגון אחר, הסר אותו קודם מ"{{name}}".',
				assignExistingClient: "שייך לקוח",
				errors: {
					displayNameRequired: "שם לקוח נדרש",
					emailRequired: "אימייל נדרש",
					selectExistingClient: "בחר לקוח מהרשימה",
					saveOrganizationFailed: "שמירת הארגון נכשלה. נסה שוב.",
				},
				details: "פרטים",
				orders: "הזמנות",
				invoices: "חשבוניות",
				ordersHistory: "היסטוריית הזמנות",
				invoicesHistory: "היסטוריית חשבוניות",
				noOrders: "לא נמצאו הזמנות",
				noInvoices: "לא נמצאו חשבוניות",
				invoiceNumber: "מספר חשבונית",
			},
			organizationGroupsPage: {
				title: "קבוצות ארגונים",
				createOrganizationGroup: "צור קבוצת ארגונים",
				name: "שם",
				namePlaceholder: "הכנס שם קבוצת ארגונים",
				actionsLabel: "פעולות",
				confirmDelete: "האם אתה בטוח שברצונך למחוק את קבוצת הארגונים הזו?",
			},
			suppliersPage: {
				title: "ספקים",
				createSupplier: "צור ספק",
				editSupplier: "ערוך ספק",
				name: "שם",
				code: "קוד ספק",
				namePlaceholder: "הכנס שם ספק",
				codePlaceholder: "הכנס קוד ספק",
				actionsLabel: "פעולות",
				confirmDelete: "האם אתה בטוח שברצונך למחוק את הספק הזה?",
			},
			invoiceDetails: {
				title: "פרטי חשבונית",
				description: "הזן פרטי חשבונית עבור {{count}} הזמנות שנבחרו",
				invoiceDate: "תאריך חשבונית",
				customerName: "שם בחשבונית",
				customerNamePlaceholder: "הכנס שם לחשבונית",
				customerAddress: "כתובת",
				customerAddressPlaceholder: "הכנס כתובת",
				createInvoice: "צור חשבונית",
				errors: {
					dateRequired: "תאריך חשבונית נדרש",
					nameRequired: "שם בחשבונית נדרש",
					addressRequired: "כתובת נדרשת",
				},
			},
			deliveryNoteDetails: {
				title: "צור תעודת משלוח",
				description: "יצירת תעודת משלוח עבור {{count}} הזמנות",
				deliveryNoteDate: "תאריך תעודת משלוח",
				createDeliveryNote: "צור תעודת משלוח",
				errors: {
					dateRequired: "תאריך תעודת משלוח נדרש",
				},
			},
			deliveryNotesPage: {
				deliveryNoteNumber: "מספר תעודת משלוח",
				invoiceNumber: "מספר חשבונית",
				order: "הזמנה",
				date: "תאריך",
				client: "לקוח",
				organization: "ארגון",
				billingAccount: "חשבון חיוב",
				amount: "סכום",
				status: "סטטוס",
				ordersFound: "הזמנות שנמצאו",
				ordersFoundDescription: "הזמנות עבור הארגון והתאריכים שנבחרו",
				selectedOrders: "נבחרו {{count}} הזמנות",
				clearSelection: "בטל בחירה",
				createDeliveryNote: "צור תעודת משלוח",
				exportToExcel: "ייצא ל-Excel",
				noOrdersFound: "לא נמצאו הזמנות",
				noOrdersFoundDescription: "לא נמצאו הזמנות עבור הארגון והתאריכים שנבחרו",
				deliveryNotesTitle: "תעודות משלוח",
				deliveryNotesDescription: "כאן תוכל לנהל את כל תעודות המשלוח",
			},
			productsPage: {
				addProduct: "הוסף מוצר",
				tabAll: "הכל",
				tabWithoutImage: "ללא תמונה",
				tabWithoutPurchasePrice: "ללא מחיר רכישה",
				noImageEmptyTitle: "אין מוצרים ללא תמונה",
				noImageEmptyDescription: "כל המוצרים כוללים תמונה",
				noPurchasePriceEmptyTitle: "אין מוצרים ללא מחיר רכישה",
				noPurchasePriceEmptyDescription: "כל המוצרים כוללים מחיר רכישה",
				missingFromSearchIndex:
					"המוצר קיים במערכת אך לא מופיע באינדקס החיפוש — כנראה שסנכרון החיפוש נכשל. פתחו אותו בעריכה ולחצו שמירה כדי להחזיר אותו לחיפוש ולחנות.",
				hiddenFromStore: "מוסתר — לא מוצג בחנות",
				deleteProductTitle: "מחיקת מוצר",
				deleteProductMessage: "האם אתה בטוח שברצונך למחוק את המוצר {{name}}? פעולה זו לא ניתנת לביטול.",
			},
			productForm: {
				validationFailed: "יש שדות חובה חסרים או לא תקינים. בדוק את השדות המסומנים באדום.",
				saveFailed: "שמירת המוצר נכשלה. נסה שוב.",
				isPublished: "מוצג בחנות",
				edit: {
					title: "ערוך מוצר",
				},
				add: {
					title: "הוסף מוצר",
				},
			},
		},
	},
};

i18n
	.use(initReactI18next) // passes i18n down to react-i18next
	.init({
		defaultNS,
		resources,
		lng: "he", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
		// you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
		// if you're using a language detector, do not define the lng option

		interpolation: {
			escapeValue: false, // react already safes from xss
		},
		ns: ["common"],
		debug: CONFIG.DEV,
	});

export { i18n };
